<template>
  <div class="navigator">
        <!-- <Logo /> -->
    <ul class="header-gnb">
      <router-link v-for="menu in menus" :key="menu.name" :to="{name: menu.name}" tag="li">
        <i :class="menu.icon"></i> 
        <span> {{menu.title}} </span>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { MENU } from '@/common/resources/const'
import Logo from '@/components/layout/header/Logo'

export default {
  components: { Logo },
  data() {
    return {
      menus: [
        // {title: '홈', name: MENU.COMPANY_MANAGER},
        // {title: '설정', name: MENU.USER_MANAGER, idx: '2', icon: "el-icon-s-tools"},
      ],
    }
  }
}
</script>

<style lang="less" scope src="@/assets/css/header.less"> </style>